var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128,
    y1: 136.199,
    x2: 128,
    y2: 23.211
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.494,
    y1: 80.328,
    x2: 71.506,
    y2: 80.328
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M123.526,25.476c0,0-54.17,46.989,0,108.804"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M132.477,25.476c0,0,54.169,46.989,0,108.804"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M188.198,80.289c0,33.246-26.952,60.198-60.198,60.198c-33.249,0-60.194-26.952-60.194-60.198S94.751,20.099,128,20.099 C161.246,20.099,188.198,47.043,188.198,80.289z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M188.11,175.035l22.803-24.697c6.686-7.246,7.974-17.02,2.857-21.732c-5.111-4.708-14.766-2.633-21.452,4.61l-16.222,17.588 c0,0-9.795,10.04-18.399,15.802c0,0-19.009,11.041-19.009,27.34l-0.049,41.956l49.534-0.448 c-1.33-19.131,3.158-24.361,3.158-24.361l41.399-54.057V66.742c-0.049-7.726-5.769-14.006-12.707-13.971 c-6.952,0.046-11.979,6.403-11.93,14.122v59.099"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M47.912,127.249l-0.004-60.357c0.049-7.719-4.978-14.076-11.93-14.122c-6.938-0.035-12.659,6.245-12.707,13.971l0.004,90.293 l41.395,54.057c0,0,4.488,5.23,3.158,24.361l49.534,0.448l-0.049-41.956c0-16.299-19.009-27.34-19.009-27.34 c-8.605-5.762-18.392-15.802-18.392-15.802l-16.229-17.588c-6.679-7.243-16.334-9.319-21.452-4.61 c-5.111,4.712-3.823,14.486,2.864,21.732l22.803,24.697"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.fb06180bfee2503147828d4fe9ddc802.svg";
export { ForwardRef as ReactComponent };